import { z } from "zod";

export const IM30_RESPONSE_CODES = {
  "00": "approved",
  "01": "rejected",
  "02": "authorizer_no_response",
  "05": "no_transaction_to_void",
  "06": "card_not_supported",
  "07": "transaction_cancelled",
  "09": "card_read_error",
  "10": "amount_below_minimum",
  "11": "no_sale_found",
  "12": "transaction_not_supported",
  "78": "multimerchant_not_active",
  "79": "single_merchant_not_active",
  "90": "init_success",
  "91": "init_failure",
} as const;

export type Im30ResponseCode = keyof typeof IM30_RESPONSE_CODES;

export const IM30_INTERMEDIATE_CODES = {
  "81": "entering_pin",
  "82": "sending_to_authorizer",
  "83": "menu_selection",
  "84": "operate_card",
  "85": "instalment_selection",
  "86": "instalment_entry",
  "87": "instalment_confirmation",
  "88": "instalment_query_accept",
  "93": "querying_instalments",
} as const;

export type Im30IntermediateCode = keyof typeof IM30_INTERMEDIATE_CODES;

export const IM30_CARD_ABBREV = {
  VI: "Visa",
  MC: "Mastercard",
  AX: "American Express",
  DC: "Diners",
  MG: "Magna",
  DB: "Redcompra (débito)",
} as const;

export type Im30CardAbbrev = keyof typeof IM30_CARD_ABBREV;

export const IM30_CARD_TYPE = {
  CR: "credit",
  DB: "debit",
} as const;

export type Im30CardType = keyof typeof IM30_CARD_TYPE;

export const IM30_CARD_PROCESSING = {
  F: "fallback",
  B: "magstripe",
  E: "chip",
  C: "contactless",
} as const;

export type Im30CardProcessing = keyof typeof IM30_CARD_PROCESSING;

export const im30SaleResponseSchema = z.object({
  responseCode: z.string().regex(/^\d{2}$/),
  commerceCode: z.string(),
  terminalId: z.string(),
  ticket: z.string(),
  authCode: z.string().optional(),
  amount: z.number().int().nonnegative(),
  last4: z
    .string()
    .regex(/^\d{4}$/)
    .optional(),
  opNumber: z.string().optional(),
  cardType: z.enum(["CR", "DB"]).optional(),
  // The manual says 2 chars (VI, MC, AX…) but a cosmetic field must never
  // invalidate a money verdict. Newer APKs trim the field and keep it only as
  // 1-4 alphanumerics; the production APK (versionCode 2) does not, so any
  // unexpected value is dropped here (.catch) instead of failing the parse.
  cardAbbrev: z.string().max(4).optional().catch(undefined),
  txDate: z
    .string()
    .regex(/^\d{8}$/)
    .optional(),
  txTime: z
    .string()
    .regex(/^\d{6}$/)
    .optional(),
  voucher: z.string().optional(),
  raw: z.string(),
});

export type Im30SaleResponse = z.infer<typeof im30SaleResponseSchema>;
